let scriptPromise = null;

export const loadGoogleMaps = () => {
  if (typeof window === 'undefined') return Promise.reject(new Error('No window'));
  if (window.google?.maps) return Promise.resolve();
  if (scriptPromise) return scriptPromise;

  const key = process.env.REACT_APP_GOOGLE_MAPS_KEY;
  if (!key || key === 'your_google_maps_api_key') {
    return Promise.reject(new Error('Google Maps API key not configured'));
  }

  scriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places`;
    script.async = true;
    script.defer = true;
    script.onload = resolve;
    script.onerror = () => {
      scriptPromise = null;
      reject(new Error('Failed to load Google Maps'));
    };
    document.head.appendChild(script);
  });

  return scriptPromise;
};

export const parseAddressComponents = (components = []) => {
  const get = (type) => components.find(c => c.types.includes(type))?.long_name || '';

  const streetNumber = get('street_number');
  const route = get('route');
  const sublocality = get('sublocality_level_1') || get('sublocality');
  const premise = get('premise');
  const addressLine = [premise, streetNumber, route, sublocality].filter(Boolean).join(', ');

  return {
    address: addressLine,
    city: get('locality') || get('administrative_area_level_2'),
    state: get('administrative_area_level_1'),
    pincode: get('postal_code'),
    country: get('country'),
  };
};
